import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ff210994"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  role: "tabpanel",
  class: "tab-pane data-panel",
  id: "data"
}
const _hoisted_2 = { class: "tab-content" }
const _hoisted_3 = {
  id: "profile",
  class: "tab-pane fade in active"
}
const _hoisted_4 = { style: {"margin":"2rem 0"} }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]

import { computed } from "vue";
import { OrganisationAndMembersApiModel } from "../../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'accredited-user-area-data-tab',
  props: {
    model: {}
  },
  emits: ["revalidate-org-data"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const revalidateOrgData = () => {
  emit("revalidate-org-data");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, [
            _createElementVNode("a", {
              href: '/myorganisation/heatmap/' + _ctx.model.id,
              target: "_blank",
              rel: "noopener noreferrer"
            }, "Organisation Heatmap", 8, _hoisted_5)
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("a", {
              href: '/myorganisation/report/' + _ctx.model.id,
              target: "_blank",
              rel: "noopener noreferrer"
            }, "View Organisation Report", 8, _hoisted_6)
          ])
        ])
      ])
    ])
  ]))
}
}

})